import {
  get as getCookie,
  remove as removeCookie,
} from "../../../js/utils/cookie/cookie";
import Lightbox from "../../elements/lightbox/lightbox";
import { COOKIES } from "../../../js/constants";

class PaypalErrorLightbox extends Lightbox {
  /**
   * extended lightbox that shows the paypal error message
   * if there is a Paypal error cookie on the page
   *
   * @param {HTMLElement} element - paypal error lightbox
   */
  constructor(element) {
    super(element);

    this.lightboxLink = this.element.querySelector(".js-Lightbox-link");
    this.lightboxCopy = this.element.querySelector(".js-Lightbox-copy");
    this.PaypalError = getCookie(COOKIES.PAYPAL_ERROR);

    if (this.PaypalError) {
      this._init();
    }
  }

  /**
   * remove the PAYPAL_ERROR and opens a lightbox
   *
   *@private
   */
  _init() {
    removeCookie(COOKIES.PAYPAL_ERROR, { path: "/" });
    this.lightboxCopy.innerHTML = this.PaypalError;
    if (this.lightboxLink) {
      this.lightboxLink.addEventListener(
        "click",
        PaypalErrorLightbox._onLinkClick
      );
    }
    this.openLightbox();
  }

  /**
   * reloads the page
   *
   *@private
   */
  static _onLinkClick() {
    window.location.reload();
  }
}

export default PaypalErrorLightbox;
